import { MissionEventHandler } from "../mission";
import ADSBMarkerSet, {MAX_MARKER_MISS_TIME} from "./adsbMarkerSet"

const MAX_MARKER_TIME = 20 * 60 * 1000 // 5s


export default class RegionADSB extends MissionEventHandler {
  constructor(mission, parentLayer) {
    super(mission)

    this.markerSet = new ADSBMarkerSet("ADSB", {maxLastSeen:10000}, parentLayer)
 
    this.boundsLayer = L.layerGroup()
    this.boundsLayer.addTo(this.markerSet.layer)
    addOverlay("Bounds", this.boundsLayer, this.markerSet.parentSegment)

    this.updateBoundsRect()
  }

  updateBoundsRect() {
    if (this.boundsRect) {
      this.boundsRect.removeFrom(this.boundsLayer)
    }

    // TODO: Use the bounds attached to the mission object on state changes so the replay will show bounds changes
    let bounds = this.mission.serverState.bounds
    if (!bounds) return
    bounds = L.latLngBounds([[bounds.north, bounds.west], [bounds.south, bounds.east]])
    this.boundsRect = L.rectangle(bounds, {color: "#ff7800", weight: 2, fill: false, dashArray: "4 10"})
    this.boundsRect.addTo(this.boundsLayer)
  }

  handleSyncCompleted(message) {
    this.updateBoundsRect()
  }

  handleMissionIndexJump(index) {
    this.clearMarkers()
    const now = this.mission.history[index].timestamp

    let pastIndex = index
    while (pastIndex > 0 && now - this.mission.history[pastIndex].timestamp < MAX_MARKER_MISS_TIME) pastIndex--
    for (let i = pastIndex; i <= index; i++) {
      this.handleMissionStep(this.mission.history[i])
    }
  }

  handleMissionStep(msg, now) {
    this.cleanOldMarkers(msg.timestamp)
    if (msg.type === "AIR_TRAFFIC") {
      this.markerSet.update(msg.data, msg.timestamp)
    } else if (msg.type === "MISSION_STATE") {
      this.updateBoundsRect()
    }
  }

  handleMissionHistoryLoad() {
    this.updateBoundsRect()
  }

  clearMarkers() {
    this.markerSet.clear()
  }

  cleanup() {
    super.cleanup()
    this.markerSet.cleanup()
    if (this.boundsRect) this.boundsRect.removeFrom(this.boundsLayer)
  }

  cleanOldMarkers(now) {
    this.markerSet.clean(now)
  }
}